import PropTypes from "prop-types"

const TotalEmployeesShape = {
  year: PropTypes.number,
  totalActive: PropTypes.number,
  totalInactive: PropTypes.number,
  totalJoined: PropTypes.number,
}

export default TotalEmployeesShape



// WEBPACK FOOTER //
// ./src/state/shapes/TotalEmployeesShape.js